import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

@Directive({
    selector: 'input[alphabetOnly]',
    providers: [{ provide: NG_VALIDATORS, useExisting: AlphabetDirective , multi: true}]
})
export class AlphabetDirective implements Validator {
    @Input() allowNumbers: boolean = false;

    constructor(private _el: ElementRef) {
    }

    validate(control: AbstractControl): { [key: string]: any } {
        const isValid      = !control.value || (!control.value.startsWith(' ') && !control.value.endsWith(' '));
        return isValid ? null : { 'whitespace': true };
    }

    @HostListener('input', ['$event']) onInputChange(event: any) {
        const initialValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initialValue.trim();

        // Choose regex based on allowNumbers input
        const regex = this.allowNumbers ? /[^a-zA-Z0-9-' ]/g : /[^a-zA-Z-' ]/g;
        this._el.nativeElement.value = this._el.nativeElement.value.replace(regex, '');

        if (initialValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
